import { defineComponent as C, useTemplateRef as _, inject as m, ref as L, onMounted as g, onBeforeUnmount as B, createElementBlock as u, openBlock as v, Fragment as N, createCommentVNode as S, createElementVNode as O, unref as t, normalizeClass as A, createVNode as c, withCtx as E, mergeProps as z, renderSlot as I } from "vue";
import k from "../Button.vue2.js";
import { SidebarOpenKey as R } from "../Page/PageSidebar.vue2.js";
import { AngleLeftIcon as x } from "../../packages/icons/dist/esm/icons/angle-left-icon.js";
import { AngleRightIcon as K } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import { isElementInView as f } from "../../util.js";
import b from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Nav/nav.js";
import { NavHorizontalKey as P, NavScrollableKey as $ } from "./Nav.vue2.js";
const G = /* @__PURE__ */ C({
  name: "PfNavList",
  inheritAttrs: !1,
  __name: "NavList",
  props: {
    backScrollAriaLabel: { default: "Scroll back" },
    forwardScrollAriaLabel: { default: "Scroll forward" }
  },
  setup(F) {
    const d = _("navListRef"), p = m(P), h = m($), w = m(R, !1), n = L(!1), o = L(!1);
    g(() => {
      window.addEventListener("resize", i, !1);
    }), B(() => {
      window.removeEventListener("resize", i, !1);
    });
    function i() {
      const e = d.value;
      e && (n.value = f(e, e.firstElementChild, !1), o.value = f(e, e.lastElementChild, !1), h && (h.value = !n.value || !o.value));
    }
    function V() {
      const e = d.value;
      if (e) {
        const a = Array.from(e.children);
        let s, r;
        for (let l = 0; l < a.length && !s; l++)
          f(e, a[l], !1) && (s = a[l], r = a[l - 1]);
        r && (e.scrollLeft -= r.scrollWidth), i();
      }
    }
    function y() {
      const e = d.value;
      if (e) {
        const a = Array.from(e.children);
        let s, r;
        for (let l = a.length - 1; l >= 0 && !s; l--)
          f(e, a[l], !1) && (s = a[l], r = a[l + 1]);
        r && (e.scrollLeft += r.scrollWidth), i();
      }
    }
    return (e, a) => (v(), u(N, null, [
      t(p) && (!n.value || !o.value) ? (v(), u("div", {
        key: 0,
        class: A(t(b).navScrollButton)
      }, [
        c(k, {
          variant: "plain",
          "aria-label": e.backScrollAriaLabel,
          disabled: n.value,
          tabindex: t(w) ? void 0 : -1,
          onClick: V
        }, {
          icon: E(() => [
            c(t(x))
          ]),
          _: 1
        }, 8, ["aria-label", "disabled", "tabindex"])
      ], 2)) : S("", !0),
      O("ul", z({ ref: "navListRef" }, e.$attrs, {
        class: t(b).navList,
        onScrollPassive: i
      }), [
        I(e.$slots, "default")
      ], 16),
      t(p) && (!n.value || !o.value) ? (v(), u("div", {
        key: 1,
        class: A(t(b).navScrollButton)
      }, [
        c(k, {
          variant: "plain",
          "aria-label": e.forwardScrollAriaLabel,
          disabled: o.value,
          tabindex: t(w) ? void 0 : -1,
          onClick: y
        }, {
          icon: E(() => [
            c(t(K))
          ]),
          _: 1
        }, 8, ["aria-label", "disabled", "tabindex"])
      ], 2)) : S("", !0)
    ], 64));
  }
});
export {
  G as default
};
